import { MouseEventHandler } from 'react';

import { useAppDispatch } from '@/hooks/redux';
import { deleteLoanOffer } from '@/redux/loans/loansSlice';

interface CancelButtonProps {
  id: number;
  onCancel?: TOnCancel;
}

export type TOnCancel = () => void;

const CancelButton: React.FC<CancelButtonProps> = ({ id, onCancel }) => {
  const dispatch = useAppDispatch();

  const handleCancel: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation();
    await dispatch(deleteLoanOffer(id)).unwrap();
    onCancel?.();
  };

  return (
    <button onClick={handleCancel} className='rounded w-[85px] h-[39px] flex items-center justify-center font-semibold text-xs/3 text-rose !bg-rose/15 m-auto'>
      Cancel
    </button>
  );
};
export default CancelButton;
